<template>
  <v-container class="vue-contentido">
    <v-tabs
      show-arrows
      next-icon="fa-caret-right"
      prev-icon="fa-caret-left"
      background-color="blue-grey lighten-4"
      horizontal
    >
      <v-tab> <v-icon left>folder</v-icon>Sectores </v-tab>
      <v-tab> <v-icon left>work</v-icon>Entidades </v-tab>
      <!-- Sector -->
      <v-tab-item>
        <v-container v-if="DataSectores !== null" grid-list-xl>
          <div class="vue-contentido">
            <v-divider></v-divider>

            <v-layout row wrap flex>
              <v-flex xs12>
                <v-card :elevation="2" :loading="loading" :disabled="loading">
                  <v-card-title>Administración de Sectores</v-card-title>
                  <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchsectores"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-card-text active-class="deep-purple accent-4 white--text">
                    <v-flex xs12 sm12>
                      <v-data-table
                        :headers="headersectores"
                        :items="DataSectores"
                        class="elevation-1"
                        :no-data-text="gnodata"
                        :no-results-text="gnodata"
                        sort-text="prueba ordenar"
                        :items-per-page="10"
                        :search="searchsectores"
                      >
                        <template v-slot:top>
                          <v-toolbar>
                            <v-toolbar-title>Lista de sectores</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>

                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-large
                                  v-on="on"
                                  @click="newsector"
                                  v-scroll-to="'#containera'"
                                >
                                  <v-icon color="primary">add</v-icon>
                                </v-btn>
                              </template>
                              <span>Agregar</span>
                            </v-tooltip>
                          </v-toolbar>
                        </template>
                        <template v-slot:item.activo="{ item }">
                          <v-simple-checkbox
                            v-model="item.activo"
                            disabled
                          ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                v-on="on"
                                small
                                class="mr-2"
                                @click="grideditsector(item)"
                                v-scroll-to="'#containera'"
                                >edit</v-icon
                              >
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:footer>
                          <div id="div1" style="width: 100%; align: right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <download-excel
                                  id="div2"
                                  style="width: 100%; text-align: right"
                                  v-show="DataSectores.length > 0"
                                  class="btn btn-default"
                                  :data="DataSectoresDownload"
                                  :exportFields="exportable"
                                  name="Sectores.xls"
                                  type="xls"
                                  worksheet="Información"
                                >
                                  <v-icon
                                    color="secondary"
                                    v-on="on"
                                    large
                                    elevation="2"
                                    >mdi-file-download-outline</v-icon
                                  >
                                </download-excel>
                              </template>
                              <span>Descargar</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-data-table>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-card-text>

                  <v-card v-show="framesector" id="containera" ref="containera">
                    <v-card-text>
                      <v-flex row wrap>
                        <v-flex sm8 xs12>
                          <v-text-field
                            v-model="Editedsector.nombre"
                            label="Nombre sector: *"
                            v-validate="'required|max:100|sectorunico:' + Editedsector.idsector" 
                            :counter="100"
                            data-vv-name="nombresector"
                            data-vv-scope="sector"
                            :error-messages="errors.collect('nombresector','sector')"
                          ></v-text-field>
                        </v-flex> 
                        <v-flex sm4 xs12 >
                              <v-flex row wrap>
                              <v-flex sm3>
                              <v-checkbox
                                v-model="Editedsector.activo"
                                :disabled="ValidarSectorConEntidades(Editedsector.idsector)"
                                label="Activo"
                                data-vv-scope="sector">
                              </v-checkbox>
                              </v-flex>
                              <v-flex sm1>
                              <div v-show="Editedsector.mostrarTooltipActivo">
                                <v-tooltip top >
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-on="on"
                                      small
                                      class="mt-6 "
                                      @click="Editedsector.mostrarTooltipActivo = Editedsector.mostrarTooltipActivo"
                                      v-scroll-to="'#containera'"
                                      >info</v-icon
                                    >
                                  </template>
                                  <span>No se puede desactivar un sector con entidades</span>
                                </v-tooltip>
                              </div>
                              </v-flex>
                              </v-flex>
                        </v-flex>
                      </v-flex> 
                      <v-felx sm12 xs12 >
                        <v-card disabled="true">
                          <v-data-table
                            :headers="headerentidadescorto"
                            :items="DataEntidades.filter(e => e.idsector == Editedsector.idsector)"
                            class="elevation-1"
                            :no-data-text="gnodata"
                            :no-results-text="gnodata"
                            :items-per-page="100"
                          > 
                          <template v-slot:item.activo="{ item }">
                            <v-simple-checkbox
                              v-model="item.activo"
                              disabled
                            ></v-simple-checkbox>
                          </template>                        
                        </v-data-table>
                      </v-card>
                        </v-felx>                     
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mx-1"
                            v-on="on"
                            color="blue darken-1"
                            @click="cerrarsectorlocal"
                          >
                            <div class="text-white">Cancelar</div>
                          </v-btn>
                        </template>
                        <span>Cancelar</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mx-1"
                            v-on="on"
                            color="blue darken-1"
                            data-vv-scope="sector"
                            @click="preventguardar"
                          >
                            <div class="text-white">Guardar</div>
                          </v-btn>
                        </template>
                        <span>Guardar</span>
                      </v-tooltip>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </div>

          <v-snackbar
            v-model="snack"
            :timeout="timeoutsnak"
            :color="MesaggeInfo.color"
          >
            {{ this.MesaggeInfo.codigoRespuesta }}
            {{ this.MesaggeInfo.mensajeRespuesta }}
            <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
            <v-btn text v-show="snackalert" @click="cancelsave">Cancelar</v-btn>
          </v-snackbar>
        </v-container>
      </v-tab-item>
      <!-- Entidad -->
      <v-tab-item>
        <v-container v-if="DataEntidades !== null" grid-list-xl>
          <div class="vue-contentido">
            <v-divider></v-divider>

            <v-layout row wrap>
              <v-flex xs12>
                <v-card :elevation="2" :loading="loading" :disabled="loading">
                  <v-card-title>Administración de Entidades</v-card-title>
                  <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchentidades"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-card-text active-class="deep-purple accent-4 white--text">
                    <v-flex xs12 sm12>
                      <v-data-table
                        :headers="headerentidades"
                        :items="DataEntidades"
                        class="elevation-1"
                        :no-data-text="gnodata"
                        :no-results-text="gnodata"
                        sort-text="prueba ordenar"
                        :items-per-page="10"
                        :search="searchentidades"
                      >
                      <template v-slot:item.activo="{ item }">
                          <v-simple-checkbox
                            v-model="item.activo"
                            disabled
                          ></v-simple-checkbox>
                        </template>                      
                        <template v-slot:top>
                          <v-toolbar>
                            <v-toolbar-title
                              >Lista de entidades</v-toolbar-title
                            >
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>

                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-large
                                  v-on="on"
                                  @click="newentidad"
                                  v-scroll-to="'#containere'"
                                >
                                  <v-icon color="primary">add</v-icon>
                                </v-btn>
                              </template>
                              <span>Agregar</span>
                            </v-tooltip>
                          </v-toolbar>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                v-on="on"
                                small
                                class="mr-2"
                                @click="grideditentidad(item)"
                                v-scroll-to="'#containere'"
                                >edit</v-icon
                              >
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:footer>
                          <div id="div1" style="width: 100%; align: right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <download-excel
                                  id="div2"
                                  style="width: 100%; text-align: right"
                                  v-show="DataEntidadesDownload.length > 0"
                                  class="btn btn-default"
                                  :data="DataEntidadesDownload"
                                  :exportFields="exportableEntidad"
                                  name="Entidades.xls"
                                  type="xls"
                                  worksheet="Información"
                                >
                                  <v-icon
                                    color="secondary"
                                    v-on="on"
                                    large
                                    elevation="2"
                                    >mdi-file-download-outline</v-icon
                                  >
                                </download-excel>
                              </template>
                              <span>Descargar</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-data-table>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-card-text>

                  <v-card
                    v-show="frameentidad"
                    id="containere"
                    ref="containere"
                  >
                    <v-form ref="formEntidad">
                      <v-card-text>
                        <v-flex row wrap>
                          <v-flex sm5 xs12>
                            <v-text-field
                              v-model="Editedentidad.nombre"
                              label="Nombre entidad: *"
                              v-validate="
                                'required|max:100|entidadunica:' + Editedentidad.identidad
                              "
                              :counter="100"
                              data-vv-name="nombreentidad"
                              data-vv-scope="entidad"
                              :error-messages="errors.collect('nombreentidad', 'entidad')"
                            ></v-text-field>
                          </v-flex>
                          
                          <v-flex xs12 sm2 md2>
                            <v-checkbox
                              v-model="Editedentidad.activo"
                              label="Activo"
                            ></v-checkbox>
                          </v-flex>


                          <v-flex sm5 xs12>
                            <v-select
                              :items="gsectores.filter(e => e.activo == true)"
                              v-model="Editedentidad.idsector"
                              item-text="nombre"
                              item-value="idsector"
                              label="Sector *"
                              v-validate="'required'"
                              data-vv-name="sector"
                              data-vv-scope="entidad"
                              :error-messages="errors.collect('sector','entidad')"
                            ></v-select>
                          </v-flex>
                        </v-flex>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="mx-1"
                              v-on="on"
                              color="blue darken-1"
                              @click="cerrarentidadlocal"
                            >
                              <div class="text-white">Cancelar</div>
                            </v-btn>
                          </template>
                          <span>Cancelar</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="mx-1"
                              v-on="on"
                              color="blue darken-1"
                              @click="preventguardarentidad"
                            >
                              <div class="text-white">Guardar</div>
                            </v-btn>
                          </template>
                          <span>Guardar</span>
                        </v-tooltip>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </div>

          <v-snackbar
            v-model="snack"
            :timeout="timeoutsnak"
            :color="MesaggeInfo.color"
          >
            {{ this.MesaggeInfo.codigoRespuesta }}
            {{ this.MesaggeInfo.mensajeRespuesta }}
            <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
            <v-btn text v-show="snackalert" @click="cancelsave">Cancelar</v-btn>
          </v-snackbar>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from 'lodash';
// import store from "../../stores/index.js";
export default {
  name: "adminsectorentidad",
  data() {
    return {
      mostrarTooltipCheckboxActivo: false,
      //Datos de las personas
      DataSectores: [],
      DataSectoresDownload: [],
      DataEntidades: [],
      DataEntidadesDownload: [],
      searchsectores: "",
      searchentidades: "",
      Editedsector: [],
      Editedentidad: [],
      framesector: false,
      frameentidad: false,
      Editarsector: false,
      Editarentidad: false,
      editedsectorIndex: -1,
      editedentidadIndex: -1,
      CargoSectores: false,
      CargoEntidades: false,
      headersectores: [
        { text: "Nombre sector", value: "nombre", align: "left", width: "80%", },
        { text: "Entidad", value: "conteoEntidad", width: "12%", align: "left",},
        { text: "Activo", value: "activo", sortable: false, width: "8%", align: "right",},
        { text: "Acciones", value: "action", sortable: false, width: "8%", align: "right", },
      ],
      headerentidades: [
        {
          text: "Nombre entidad",
          value: "nombre",
          align: "left",
          width: "82%",
        },
        { text: "Activo", value: "activo", width: "10%", align: "center",},
        {
          text: "Acciones",
          value: "action",
          sortable: false,
          width: "8%",
          align: "right",
        },
      ],

      headerentidadescorto: [
        { text: "Nombre entidad", value: "nombre", align: "left", width: "82%", },
        { text: "Activo", value: "activo", width: "10%", align: "center",},
      ],

      exportable: {
        ID: "idsector",
        Nombre: "nombre",
        Activo: "activo",
      },
      exportableEntidad: {
        ID: "identidad",
        Nombre: "nombre",
        Sector: "nombresector"
      },

      SelectionSector: [],
      //elementos del formulario
      buttonguardarestado: false,
      buttonfinalizarestado: false,
      loading: false,

      //campos del cuadro de dialog de mensajes
      snack: false,
      snackalert: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      timeoutsnak: 4000,
      buttontext: "cerrar",

      //Validacion de campos
      dictionary: {
        custom: {
          nombresector: {
            required: () => "El nombre del sector es un campo obligatorio",
            alpha_spaces: "Los valores ingresados",
            max: "está superando el límite de caracteres",
          },
        },
      },
      dictionaryEntidad: {
        custom: {
          nombreentidad: {
            required: () => "El nombre de la entidad es un campo obligatorio",
            alpha_spaces: "Los valores ingresados",
            max: "está superando el límite de caracteres"
          },
          sector:{
            required: () => "El sector de la entidad es un campo obligatorio",
          }
        },
      },
    };
  },
  methods: {
    ...mapActions([
      "get_sectores",
      "Getentidad",
      "PutEntidad",
      "get_sectoredit",
      "PutSector",
      "get_entidadesbysector"
    ]),
    ValidarSectorConEntidades(idsector) {
      return (
        this.DataEntidades.filter(e => e.idsector == idsector && e.activo == true).length > 0
      );
    },
    SaveSector() {
      this.loading = true;
      this.PutSector({
        data: this.Editedsector,
      });
    },
    SaveEntidad() {
      this.loading = true;
      this.PutEntidad({
        data: this.Editedentidad,
      });
    },
    cancelsave() {
      this.snackalert = false;
      this.snack = false;
      this.buttontext = "cerrar";
      this.timeoutsnak = 4000;
    },
    preventguardar() {
      this.$validator.validateAll("sector").then((result) => {
        if (!result) {
          console.log(this.$validator);
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            if(element.scope == "sector")
              Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          this.Editarsector = false;
          this.guardarsectorlocal();
        }
      });
    },
    guardarsectorlocal() {
      this.snackalert = false;
      this.Editedsector.modificado = true;
      if (this.Editedsector.nombre != "") {
        if (this.Editedsector.activo == null) {
          this.Editedsector.activo = false;
        }
      }
      if (this.EditedsectorIndex > -1) {
        Object.assign(
          this.DataSectores[this.EditedsectorIndex],
          this.Editedsector
        );
      } else {
        this.DataSectores.push(this.Editedsector);
      }

      this.EditedsectorIndex = -1;
      this.SaveSector();

      this.framesector = false;
    },
    cerrarsectorlocal() {
      this.framesector = false;
      this.Editarsector = false;

      this.Editedsector = [];
    },
    grideditsector(item) {
      this.$validator.errors.clear('sector');
      this.framesector = true;
      this.Editarsector = true;
      this.EditedsectorIndex = this.DataSectores.indexOf(item);
      this.Editedsector = Object.assign({}, item);
      this.Editedsector.mostrarTooltipActivo = this.ValidarSectorConEntidades(item.idsector);
    },
    newsector() {
      this.EditedsectorIndex = -1;
      this.Editarsector = false;
      this.framesector = true;
      
      //this.Editedpersona = Object.assign({}, this.DataPersonas[1]);
      this.Editedsector = {
        idsector: 0,
        nombre: "",
        activo: true,

      };
    },
    preventguardarentidad() {
      this.$validator.validateAll("entidad").then((result) => {
        if (!result) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            if(element.scope == "entidad")
              Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          this.Editarentidad = false;
          this.guardarentidadlocal();
        }
      });
    },

    guardarentidadlocal() {
      this.snackalert = false;
      this.Editedentidad.modificado = true;
      if (this.Editedentidad.nombre != "") {
        if (this.Editedentidad.activo == null) {
          this.Editedentidad.activo = false;
        }
      }
      if (this.EditedentidadIndex > -1) {
        Object.assign(
          this.DataEntidades[this.EditedentidadIndex],
          this.Editedentidad
        );
      } else {
        this.DataEntidades.push(this.Editedentidad);
      }

      this.EditedentidadIndex = -1;
      this.SaveEntidad();

      this.frameentidad = false;
    },
    cerrarentidadlocal() {
      this.frameentidad = false;
      this.Editarentidad = false;

      this.Editedentidad = [];
    },
    grideditentidad(item) {
      this.$validator.errors.clear('entidad');
      this.frameentidad = true;
      this.Editarentidad = true;
      this.EditedentidadIndex = this.DataSectores.indexOf(item);
      this.Editedentidad = Object.assign({}, item);
    },
    newentidad() {
      this.EditedentidadIndex = -1;
      this.Editarentidad = false;
      this.frameentidad = true;
      this.Editedentidad = {
        nombre: "",
      };
      //this.Editedpersona = Object.assign({}, this.DataPersonas[1]);
      this.Editedentidad = {
        identidad: 0,
        nombre: "",
        activo: true,
        identificacion: "0",
      };
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.snack = false;
        this.snackalert = false;
        this.timeoutsnak = 4000;
        this.buttontext == "cerrar";
        this.guardarsectorlocal();
      }
    },
  },
  created() {
    this.get_sectores();
    this.Getentidad();
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
    this.$validator.localize("es", this.dictionaryEntidad);
    const SectorUnico = (value, args) =>
      new Promise((resolve) => {
        setTimeout(() => {
          let sectores = this.DataSectores.filter(v => v.idsector != args[0])
          if (sectores.filter(v => v.nombre.toLowerCase() == value.toLowerCase()).length == 0) {
            return resolve({
              valid: true,
            });
          }

          return resolve({
            valid: false,
            data: {
              message: `El sector que intenta ingresar ya existe`,
            },
          });
        }, 200);
      });

    this.$validator.extend("sectorunico", {
      validate: SectorUnico,
      getMessage: (field, params, data) => data.message,
    });

    const EntidadUnica = (value, args) =>
      new Promise((resolve) => {
        setTimeout(() => {
          let entidades = this.DataEntidades.filter(v => v.identidad != args[0])
          if (entidades.filter(v => v.nombre.toLowerCase() == value.toLowerCase()).length == 0) {
            return resolve({
              valid: true,
            });
          }

          return resolve({
            valid: false,
            data: {
              message: `La entidad que intenta ingresar ya existe`,
            },
          });
        }, 200);
      });

    this.$validator.extend("entidadunica", {
      validate: EntidadUnica,
      getMessage: (field, params, data) => data.message,
    });
  },
  computed: {
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters(["gsector", "gsectores", "gsectoredit", "gentidad"]),
    combined(){
        return this.CargoSectores && this.CargoEntidades
    }
  },
  watch: {
    combined(value){
        if (value)
        {
            this.DataEntidadesDownload = _.cloneDeep(this.DataEntidades);
            let self = this;
            this.DataEntidadesDownload.forEach(function (entidad, index) {
              let sector =  self.DataSectores.filter(s => s.idsector == entidad.idsector );
              entidad.nombresector = sector[0].nombre;
            });
        }
    },
    gsectores: function () {
      this.CargoSectores = true;
      this.DataSectores = this.gsectores;
      this.DataSectoresDownload = _.cloneDeep(this.DataSectores);
      this.DataSectoresDownload.forEach(function (sector, index) {
        if(sector.activo==true) 
          sector.activo='si';
        else 
          sector.activo='no';
        });
    },
    gentidad: function () {
      this.CargoEntidades = true;
      this.DataEntidades = this.gentidad;
     
    },
    ginformation() {
      if (this.loading) {
        if (this.ginformation.idGenerado == 1) {
          this.Editedsector = [];
          this.framesector = false;
        }
        this.MesaggeInfo = this.ginformation;
        this.snack = true;
        //este console por favor dejarlo, es para que el usuario tenga en consola los posibles mensajes por si no alcanza a leerlo
        console.log(this.MesaggeInfo.mensajeRespuesta);
        this.loading = false;
        this.DataSectores = [];
        this.DataEntidades = [];
        setTimeout(() => {
          this.get_sectores();
        }, 1000);
        setTimeout(() => {
          this.Getentidad();
        }, 1000);
      }
    },
  },
};
</script>